import { SearchOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { Card, Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { InquiryFilterFormFields } from './InquiryFilterFormFields';

const FilterCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
  }
`;
const FilterButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const FilterCardTitle = styled.h2`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    font-family: ${props => props.theme.fontFamily};
    margin-bottom: 0.5em;
    line-height: 1.3;
    font-weight: 600;
  }
`;

export interface IInquiryFilterFormProps {
  buttons?: React.ReactNode;
  hideCategorySelect?: boolean;
  isRecipientTypeLocked?: boolean;
}

/**
 * Form per la ricerca di domande FrontOffice.
 */
export function InquiryFilterForm(props: IInquiryFilterFormProps) {
  const { hideCategorySelect, isRecipientTypeLocked } = props;
  const { t } = useTranslation();

  return (
    <FilterCard>
      <div role="search" aria-label="Filtri di ricerca domande">
        <FilterCardTitle>
          {t('inquiry.filtri-di-ricerca', 'Filtri di ricerca')}
        </FilterCardTitle>

        <InquiryFilterFormFields
          hideCategorySelect={hideCategorySelect}
          isRecipientTypeLocked={isRecipientTypeLocked}
        />

        <Flex vertical gap={12}>
          <SubmitButton
            block
            pristineMessage={t(
              'ui.nessun-filtro-modificato',
              'Nessun filtro modificato',
            )}
            type="primary"
            icon={<SearchOutlined aria-hidden />}
            children={t('inquiry.cerca', 'Cerca')}
          />
          {props.buttons}
        </Flex>
      </div>
    </FilterCard>
  );
}
